import React, { useContext } from 'react';
import { Button } from '../ui';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { QueryApiContext } from '../../contexts/QueryContext';

interface ChatCountBubbleProps {
  className?: string;
}

const ChatCountBubble: React.FC<ChatCountBubbleProps> = ({ className = '' }) => {
  const navigate = useNavigate();
  const restQueryClient = useContext(QueryApiContext);

  // Fetch chat conversation count from API
  const { data, isLoading, isError } = restQueryClient.chatConversations.count.useQuery(['chatConversationCount']);

  const handleChatHistory = () => {
    navigate('/chat-history');
  };

  const chatCount = data?.body ? (data.body as { count: number }).count : 0;

  // Don't render anything while loading, on error, or if count is zero
  if (isLoading || isError || chatCount === 0) {
    return <></>;
  }

  return (
    <Button
      type="button"
      plain
      className={`p-0.5 ${className}`}
      title={`View chat history (${chatCount} chats)`}
      onClick={handleChatHistory}
    >
      <ChatBubbleLeftRightIcon className="h-5 w-5 inline-block" />
      <span className="ml-1">{chatCount}</span>
    </Button>
  );
};

export default ChatCountBubble;
